import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { NgRedux } from "@angular-redux/store";
import { IAppState } from "../interfaces/appstate.interface";

import { API_URL } from "./token.service";
import { TranslateService } from "@ngx-translate/core";
import { forkJoin } from "rxjs/observable/forkJoin";

@Injectable()
export class _GlobalConstants implements OnInit, OnDestroy {
  private subscription: any;
  private globalConstants: any;
  private cachedValues: any;

  constructor(
    private http: HttpClient,
    private ngRedux: NgRedux<IAppState>,
    private translate: TranslateService
  ) {
    this.subscription = this.getGlobalConstants().subscribe((res) => {
      this.globalConstants = { ...res[0], ...res[1] };
    });
    this.cachedValues = {};
  }

  getGlobalConstants() {
    return forkJoin(
      this.http.get(`/assets/i18n/flat_en.json`),
      this.http.get(`${API_URL}/globalConstants`)
    );
  }

  getTranslatedValues(path: string) {
    if (!this.cachedValues[path]) {
      //split the path on . and loop through to find the specified array
      var paths = path.split(".");
      var array = this.globalConstants;
      for (var i = 0; i < paths.length; i++) {
        array = array[paths[i]];
      }

      //Look through the array and translate to find the display name
      var values = [];
      for (var j = 0; j < array.length; j++) {
        values.push({
          value: array[j],
          display: this.translate.instant("backend." + path + "." + array[j]),
        });
      }

      //Move this caching to use redux
      this.cachedValues[path] = values;
    }

    return this.cachedValues[path];
  }

  ngOnInit() {}

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/globalConstants.service.ts